
const API_URL = process.env.REACT_APP_GALLERY_API_URL || 'http://localhost:3005';

const getGalleries = async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await fetch(`${API_URL}/v1/galleries?${queryString}`);
    if (!response.ok) {
        throw new Error('Failed to fetch galleries');
    }
    return response.json();
};

const createGallery = async (galleryData) => {
    const response = await fetch(`${API_URL}/v1/galleries`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(galleryData),
    });
    if (!response.ok) {
        throw new Error('Failed to create gallery');
    }
    return response.json();
};

const updateGallery = async (id, galleryData) => {
    const response = await fetch(`${API_URL}/v1/galleries/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(galleryData),
    });
    if (!response.ok) {
        throw new Error('Failed to update gallery');
    }
    return response.json();
};

const deleteGallery = async (id) => {
    const response = await fetch(`${API_URL}/v1/galleries/${id}`, {
        method: 'DELETE',
    });
    if (!response.ok) {
        throw new Error('Failed to delete gallery');
    }
    return response.json();
};

const startSession = async (galleryId, metadata = {}) => {
    const response = await fetch(`${API_URL}/v1/sessions`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ galleryId, metadata }),
    });
    if (!response.ok) {
        throw new Error('Failed to start session');
    }
    return response.json();
};

const stopSession = async (sessionId) => {
    const response = await fetch(`${API_URL}/v1/sessions/${sessionId}/stop`, {
        method: 'PUT',
    });
    if (!response.ok) {
        throw new Error('Failed to stop session');
    }
    return response.json();
};

const getGalleryById = async (id) => {
    const response = await fetch(`${API_URL}/v1/galleries/${id}`);
    if (!response.ok) {
        throw new Error('Failed to fetch gallery details');
    }
    return response.json();
};

const getSessions = async (galleryId) => {
    const response = await fetch(`${API_URL}/v1/sessions/gallery/${galleryId}`);
    if (!response.ok) {
        throw new Error('Failed to fetch sessions');
    }
    return response.json();
};

const galleryService = {
    getGalleries,
    getGalleryById,
    createGallery,
    updateGallery,
    deleteGallery,
    startSession,
    stopSession,
    getSessions
};

export default galleryService;
